<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaNivel2')}}</h4>
        </div>
        <form class="add-user-form" id='edit-level1' method="POST">
            <input type="hidden" name="_method" value="put" />
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                        <div class="selections-option" v-if="input_field.inputName === 'nivel1'" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.alegeNivel1')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-sitemap"></i>
                            </div>
                            <v-select v-model="select_level1" :options="level1" label="name"></v-select>
                        </div>
                        <div v-else>
                            <input type="text" class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :name="input_field.inputName"
                                   v-model="input_field.inputValue"
                                   :data-vv-as="input_field.labelName"
                                   :id="input_field.inputName">
                            <label class=""> {{input_field.labelName}} </label>
                            <span class="focus-input"></span>
                            <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                            <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                        </div>
                    </div>
                    <div class="single-vselect">
                        <h4>{{$t('placeholder.punereInFunctiune')}}</h4>
                        <v-select v-model="pif" label="label" :options="pifs"></v-select>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName"
                               v-model="input_field.inputValue">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="save-contact-buttons col-md-12">
                    <button type="button" @click='saveLevel2()'>
                        <i class="fas fa-check"></i>
                        {{$t('placeholder.salveaza')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Level1Service from '../../api-services/nivel1.service.js'
import Level2Service from '../../api-services/nivel2.service.js'
export default {
  name: 'editcategory',
  data () {
    return {
      level1: [],
      level2: [],
      select_level1: null,
      selected_label: null,
      pif: null
    }
  },
  methods: {
    getLevel2 () {
      Level2Service.get(this.$route.params.id)
        .then((response) => {
          this.level2 = response.data.data
          this.select_level1 = this.level1.find(county => county.id === this.level2.nivel1.id)
          if (parseInt(this.level2.pif)) {
            this.pif = this.pifs.find(pif => parseInt(pif.inputValue) === parseInt(this.level2.pif))
          } else {
            alert()
            this.pif = this.pifs[0]
          }
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('hideLoading')
        })
    },
    getCategories () {
      Level1Service.getAll().then((response) => {
        this.level1 = response.data.data
        this.select_level1 = this.level1.find(county => county.id === this.level2.nivel1.id)
        this.$store.dispatch('hideLoading')
      }).catch((error) => {
        console.log(error)
        this.$store.dispatch('hideLoading')
      })
    },
    saveLevel2 () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('edit-level1'))
      if (this.select_level1) {
        formData.append('nivel1', this.select_level1.id)
      }

      if (this.pif) {
        formData.append('pif', this.pif.inputValue)
      }

      Level2Service.update(this.$route.params.id, formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.level2 = response.data.data
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.nivel2Modificat'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            console.log(input)
            console.log(input.offsetTop)
            console.log(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }

          this.$store.dispatch('hideLoading')
        })
    }
  },
  computed: {
    pifs () {
      return [
        {
          'id': 1,
          'inputValue': 0,
          'label': this.$t('placeholder.nuNecesitaPif'),
          'inputName': 'PIF'
        },
        {
          'id': 2,
          'inputValue': 1,
          'label': this.$t('placeholder.necesitaPif'),
          'inputName': 'PIF'
        }
      ]
    },
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'ord',
            labelName: this.$t('placeholder.ord'),
            inputValue: (this.level2) ? this.level2.ord : null,
            icon: 'fas fa-sort-numeric-up',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'nivel1',
            labelName: this.$t('placeholder.categorie'),
            inputValue: (this.level1 && this.level1.nivel1) ? this.level1.nivel1.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumire'),
            inputValue: (this.level2) ? this.level2.name : null,
            icon: 'fas fa-file-signature'
          }
        ],
        column_2: [
          {
            inputName: 'discount',
            labelName: this.$t('placeholder.discount'),
            inputValue: (this.level2) ? this.level2.discount : null,
            icon: 'fas fa-money-bill-wave info-tool',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'addition_min',
            labelName: this.$t('placeholder.addition_min'),
            inputValue: (this.level2) ? this.level2.addition_min : null,
            icon: 'fas fa-percentage',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'addition_distribution',
            labelName: this.$t('placeholder.addition_distribution'),
            inputValue: (this.level2) ? this.level2.addition_distribution : null,
            icon: 'fas fa-percentage',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'addition_partner',
            labelName: this.$t('placeholder.addition_partner'),
            inputValue: (this.level2) ? this.level2.addition_partner : null,
            icon: 'fas fa-percentage',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'addition_retail',
            labelName: this.$t('placeholder.addition_retail'),
            inputValue: (this.level2) ? this.level2.addition_retail : null,
            icon: 'fas fa-percentage',
            validationRules: 'alpha_num'
          }
        ]
      }
    }
  },
  created () {
    this.getLevel2()
    this.getCategories()
  }
}
</script>
